import { h, cloneElement, Component } from 'preact';

export default class FadeCard extends Component {

	static defaultProps = {
		counter: false,
		counterDelimiter: '/'
	}

	state = {
		current: 0
	}

	nextCard = () => {
		const { change, finish } = this.props;
		if(change) {
			change(this.state.current, this.props.children.length);
		}
		if(this.state.current + 1 === this.props.children.length) {
			if(finish) {
				finish();
			}
		} else {
			this.setState({ current: this.state.current + 1 });
		}
	}

	shouldShow = (index, current) => {
		if(index === current) return true;
		if(index < current && index === current - 1) return true;
		if(index > current && index === current + 1) return true;
		return false;
	}

	getClass = (index, current) => {
		if(index === current) {
			return 'current';
		}
		if(index < current) {
			return 'past';
		}
		if(index > current) {
			return 'future';
		}
	}

	render() {
		const { current } = this.state;
		const { counter, height, counterDelimiter } = this.props;
		const { nextCard } = this;

		return (
			<div className="fade-container card" ref={ node => this.container = node } style={{ height: height }}>
				<div className="fade-region">
					{
						this.props.children.map( (child, index) => {
							return (
								<div className={`fade-region__card ${this.getClass(index, current)}`}>
									{
										this.shouldShow(index, current) &&
										cloneElement(child, { nextCard, activeCard: index === current, lastCard: index === this.props.children.length - 1 })
									}
								</div>
							)
						})
					}
				</div>
				{
					counter &&
					(
						<div className="counter">{current+1} {counterDelimiter} {this.props.children.length}</div>
					)
				}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./components/fade-card/index.js